// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationsIcon_wrapper__gGGhp","badge":"NotificationsIcon_badge__A7ndm","shake":"NotificationsIcon_shake__j+zps","bellShake":"NotificationsIcon_bellShake__VUDW0"};